module.exports = __webpack_public_path__ + "static/img/banner1.55b3ce3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/imgs/newHome/banner1.jpg
// module id = uWSH
// module chunks = 1